module.exports = __webpack_public_path__ + "static/media/paperInfo.6955eefb.svg";